import { useNavigate } from "react-router-dom"
import AnimatedElement from "../../animation/AnimatedElement";

interface ISection3Home{
  images:string[],
  title:string,
  left:boolean,
  linkButton:string,
  titleButton:string,
  paragraph:string,
  titleExplain:string
  buttonActive:boolean
} 


const Section3 = (data:ISection3Home) => {
  const navigate = useNavigate();
  const {images,title,left,linkButton,buttonActive,titleButton,paragraph,titleExplain} =  data
  
  const handleNavigate = (path:string) => {
    navigate(path)
  }
  
  return (
    <div className="component-section-3-home">
      <div className="title-first-section-3-home">{title}</div>
      <>
        {
          left ? (
            <>
              <div className="container-explain-section-3-home">
                
                <div className="left-part">
                  <AnimatedElement from="left">
                    <img src={images[0]} alt="" />
                    <div className="background"/>
                  </AnimatedElement>
                </div>
                <div className="mobile">
                  <img src={images[0]} alt="" />
                  <div className="background"/>
                </div>
                <div className="right-part">
                  <div className="title-right-part">{titleExplain}</div>
                  <div className="paragraph">{paragraph}</div>
                  {
                    buttonActive ? (
                      <div className="button" onClick={() => handleNavigate(linkButton)}><span>{titleButton}</span></div>
                    ) : (
                      <div></div>
                    )
                  }
                </div>
              </div>
              <div className="container-explain-section-3-home-images">
                <div className="left-part-images">
                  <AnimatedElement from="bottom"> 
                    <img src={images[1]} alt="" />
                    <div className="background"/>
                  </AnimatedElement>
                </div>
                <div className="left-part-image-mobile">
                  <img src={images[1]} alt="" />
                  <div className="background"/>
                </div>
                <div className="right-part-images">
                  <AnimatedElement from="bottom"> 
                    <img src={images[2]} alt="" />
                    <div className="background"/>
                  </AnimatedElement>
                </div>
                <div className="right-part-images-mobile">
                  <img src={images[2]} alt="" />
                  <div className="background"/>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="container-explain-section-3-home">
                <div className="right-part">
                  <div className="title-right-part">{titleExplain}</div>
                  <div className="paragraph">{paragraph}</div>
                  {
                    buttonActive ? (
                      <div className="button" onClick={() => handleNavigate(linkButton)}><span>{titleButton}</span></div>
                    ) : (
                      <div></div>
                    )
                  }
                </div>
                <div className="left-part">
                  <AnimatedElement from="bottom"> 
                    <img src={images[0]} alt="" />
                    <div className="background right"/>
                  </AnimatedElement>
                </div>
                <div className="mobile">
                  <img src={images[0]} alt="" />
                  <div className="background"/>
                </div>
              </div>
              <div className="container-explain-section-3-home-images">
                <div className="right-part-images">
                  <AnimatedElement from="bottom"> 
                    <img src={images[2]} alt="" />
                    <div className="background right"/>
                  </AnimatedElement>
                </div>
                <div className="right-part-images-mobile">
                  <img src={images[2]} alt="" />
                  <div className="background"/>
                </div>
                <div className="left-part-images ">
                  <AnimatedElement from="bottom"> 
                    <img src={images[1]} alt="" />
                    <div className="background right"/>
                  </AnimatedElement>
                </div>
                <div className="left-part-image-mobile">
                  <img src={images[1]} alt="" />
                  <div className="background"/>
                </div>
              </div>
            </>
          )
        }
      </>
    </div>
  )
}

export default Section3